import { create } from 'zustand';

import { IAdminSearchProjectFilter } from "~/providers/admin-interfaces";

interface IProjectsFilter {
	data: {
		filter: IAdminSearchProjectFilter;
		wasSet: boolean;
	};
	setFilter: (newFilter: IAdminSearchProjectFilter) => void;
}

export const projectsFilterStore = create<IProjectsFilter>(set => ({
	data: {
		filter: {},
		wasSet: false,
	},
	setFilter: newFilter => set(() => ({
		data: {
			filter: newFilter,
			wasSet: true,
		},
	})),
}));
